var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.687499 5.5C0.69191 5.02322 0.884014 4.56738 1.22219 4.23125L5.11 0.334378C5.2798 0.165588 5.50949 0.0708466 5.74891 0.0708466C5.98832 0.0708466 6.21801 0.165588 6.38781 0.334378C6.47275 0.418625 6.54017 0.518858 6.58618 0.629292C6.63219 0.739727 6.65588 0.858179 6.65588 0.977815C6.65588 1.09745 6.63219 1.2159 6.58618 1.32634C6.54017 1.43677 6.47275 1.537 6.38781 1.62125L3.40625 4.59375H12.4687C12.7091 4.59375 12.9396 4.68923 13.1096 4.85919C13.2795 5.02914 13.375 5.25965 13.375 5.5C13.375 5.74036 13.2795 5.97086 13.1096 6.14082C12.9396 6.31077 12.7091 6.40625 12.4687 6.40625H3.40625L6.38781 9.38782C6.55846 9.55726 6.65481 9.78756 6.65566 10.028C6.65651 10.2685 6.56179 10.4995 6.39234 10.6702C6.22289 10.8408 5.9926 10.9372 5.75211 10.938C5.51162 10.9389 5.28065 10.8441 5.11 10.6747L1.22219 6.77781C0.88181 6.43947 0.689523 5.97993 0.687499 5.5Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.d885e9625bc5130bec1db4c7f67fad68.svg";
export { ForwardRef as ReactComponent };